<template>
  <div class="columnper">
    <div class="columnper_bar">
      <ul class="columnper_bar_ul">
        <li class="columnper_bar_item">
          <div
            class="columnper_bar_item_color1"
            :style="`width:${msgper[0]}`"
          ></div>
        </li>
        <li class="columnper_bar_item">
          <div
            class="columnper_bar_item_color2"
            :style="`width:${msgper[1]}`"
          ></div>
        </li>
        <li class="columnper_bar_item">
          <div
            class="columnper_bar_item_color3"
            :style="`width:${msgper[2]}`"
          ></div>
        </li>
        <li class="columnper_bar_item">
          <div
            class="columnper_bar_item_color4"
            :style="`width:${msgper[3]}`"
          ></div>
        </li>
      </ul>
    </div>
    <div class="columnper_bar_info">
      <span>已出场</span>
      <span>{{allmsg}}</span>
      <span> ({{ itemper }}吨) </span>
    </div>
  </div>
</template>
<script>
export default {
    props:{
        itemper:{
            typeof:[Number,String],
            default:0,
        },
        amount:{
            typeof:[Number,String],
            default:1
        }
    },
    computed:{
        msgper(){
            var numper=this.itemper/this.amount;
            if(numper<=0.25) return [`${(numper/0.25)*100}%`,0,0,0];
            if(numper>0.25&&numper<=0.5) return['110%',`${((numper-0.25)/0.25)*100}%`,0,0];
            if(numper>0.5&&numper<=0.75) return['110%','110%',`${((numper-0.5)/0.25)*100}%`,0];
            if(numper>0.75) return['110%','110%','110%',`${((numper-0.75)/0.25)*100}%`]
        },
        allmsg(){
            let msg=(this.itemper/this.amount)*100+'';
            msg = msg.match(/^\d+(?:\.\d{0,2})?/)+"%";
            return msg;
        }
    }
}
</script>
<style lang="scss" scoped>
.columnper {
  position: relative;
  height: 50px;
  width: 100%;
  .columnper_bar {
    height: 12px;
    width: 100%;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    .columnper_bar_ul {
      width: 100%;
      height: 100%;
      list-style: none;
      padding: 0;
      margin: 0;
      .columnper_bar_item {
        float: left;
        width: 24.8%;
        height: 100%;
        margin-right: 0.2%;
        border-radius: 12px;
        background: #f3f4f5;
        overflow: hidden;
        .columnper_bar_item_color1 {
          height: 100%;
          background: linear-gradient(90deg, #2c56bf, #3e74f3);
          border-radius: 12px;
        }
        .columnper_bar_item_color2 {
          height: 100%;
          background: linear-gradient(90deg, #3e74f3, #2da8bc);
          border-radius: 12px;
        }
        .columnper_bar_item_color3 {
          height: 100%;
          border-radius: 12px;
          background: linear-gradient(90deg, #2da8bc, #16da68);
        }
        .columnper_bar_item_color4 {
          height: 100%;
          border-radius: 12px;
          background: linear-gradient(90deg, #16da68, #39e793);
        }
      }
    }
  }
  .columnper_bar_info {
    position: absolute;
    width: 100%;
    bottom: 10%;
    font-size: 80%;
    font-weight: bold;
    color: #b7b7bd;
    & span:nth-of-type(n + 2) {
      margin-left: 10px;
    }
    & span:last-of-type {
      font-size: 80%;
      color: #666666;
      font-weight: 400;
    }
  }
}
</style>